import { useRecoilState, useRecoilValue } from "recoil";
import { authAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { totalRow } from "state/roles-permissions";

import { listCheckPaymentAtom, listReminingPaymentAtom } from "state/check-payment";

const useCheckPayment = () => {
  const [auth, setAuth] = useRecoilState(authAtom);
  const [listCheckPayment, setListCheckPayment] = useRecoilState(listCheckPaymentAtom);
  const [listReminingPayment, setListReminingPayment] = useRecoilState(listReminingPaymentAtom);
    const [totalRows, setTotalRows] = useRecoilState(totalRow);
  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };
  return {
    getListCheckPayment,
    exportCheckPayment,
    receivePaymentSelectedBooking,
    getListRemainingPayment,
    exportRemainingPayment
  };


  function getListCheckPayment(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }
    return instance({
      url: "booking/v1/reports/payment",
      method: "GET",
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setListCheckPayment(res.data.data);
          setTotalRows((preState) => ({
            ...preState,
            checkPayment: res.data.meta.total,
          }));
          return res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getListRemainingPayment(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }
    return instance({
      url: "booking/v1/reports/remaining-payment",
      method: "GET",
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setListReminingPayment(res.data.data);
          setTotalRows((preState) => ({
            ...preState,
            reminingPayment: res.data.meta.total,
          }));
          return res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function exportRemainingPayment(filter) {
    const params = {
      ...filter
    };
    headers.responseType = "blob";
    return instance({
      url: "booking/v1/reports/remaining-payment/export",
      method: "GET",
      params,
      responseType: "blob",
      headers,
    });
  }

  function exportCheckPayment(filter, page = 0, pageSize = 10) {
    const offset = page * pageSize;
    const params = {
      ...filter,
      offset,
      limit: pageSize,
    };
    headers.responseType = "blob";
    return instance({
      url: "booking/v1/reports/payment/export",
      method: "GET",
      params,
      responseType: "blob",
      headers,
    });
  }



  function receivePaymentSelectedBooking(data) {
    return instance({
      url: `booking/v1/reports/payment`,
      method: "PUT",
      data,
      headers,
    });
  }

  
}
export { useCheckPayment };
